// React
import React from "react";
import classNames from "classnames";
// Routing
import { Link } from 'react-router';
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./CollapsableList.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class CollapsableList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isExpanded: props.isDefaultExpanded };
    }
    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.isDefaultExpanded) {
            this.setState({ isExpanded: true });
        }
        else if (this.props.isDefaultExpanded != nextProps.isDefaultExpanded && nextProps.isDefaultExpanded == false) {
            this.setState({ isExpanded: false });
        }
    }
    render() {
        let { heading, url } = this.props;
        let numberOfLinks = 0;
        if (this.props.children) {
            let childrenAsArray = this.props.children;
            numberOfLinks = childrenAsArray.length;
        }
        return (React.createElement("div", { style: { height: `${(numberOfLinks * 35) + 40}px` }, className: classNames(this.props.className, styles.container, !this.state.isExpanded && styles.collapsed) },
            React.createElement(Link, { to: url, className: styles.header }, heading),
            React.createElement("div", null, this.props.children)));
    }
}
//<AnimakitExpander expanded={this.state.isExpanded} horizontal={false} durationPerPx={1.5}>
//<div>
//        {this.props.children}
//    </div>
//</AnimakitExpander>
